module.exports = __webpack_public_path__ + "img/bg_blue.3df6de69.png";